import { createFileRoute, Link, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/einstellungen")({
  component: Settings,
});

const tabs = [
  { to: "/einstellungen/konto", label: "Konto" },
  { to: "/einstellungen/nutzung", label: "Nutzung" },
] as const;

/**
 * Tabs across the top rather than a second menu down the side: the app's
 * sidebar already takes the left edge.
 */
function Settings() {
  return (
    <div className="mx-auto w-full max-w-3xl space-y-6 p-4 md:p-8">
      <div className="space-y-4">
        <h1 className="font-semibold text-2xl tracking-tight">Einstellungen</h1>
        <nav aria-label="Einstellungen" className="flex gap-1 border-b">
          {tabs.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className="-mb-px border-transparent border-b-2 px-3 py-2.5 text-muted-foreground text-sm hover:text-foreground"
              activeProps={{ className: "border-primary font-medium text-foreground" }}
            >
              {label}
            </Link>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  );
}
